import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    this.translate.addLangs(this.languages);

    let lang: string;

    if (this.cookieService.check('lang')) {
      lang = this.cookieService.get('lang');
    } else {
      const browserLang = this.translate.getBrowserLang();
      lang = browserLang === 'de' ? 'de' : 'en';
      this.cookieService.set('lang', lang);
    }

    this.translate.use(lang);
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

}
